//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: 'NotFound',
  methods: {
    goBack: function goBack() {
      this.$router.go(-1);
    }
  }
};